import { loggerInit } from "../init/SentryLogger";
import "../init/render";

loggerInit();
